import { render } from "./DentistPage.vue?vue&type=template&id=3e2dda4f"
import script from "./DentistPage.vue?vue&type=script&lang=js"
export * from "./DentistPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__